// ** Icon Imports
import { Icon } from '@iconify/react'

const IconifyIcon = ({ icon, ...rest }) => {
    return <Icon icon={icon} fontSize='1.5rem' {...rest} />
}

export default IconifyIcon
